import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const WhooshIconColor = (props: IconProps) => (
  <Icon viewBox="0 0 45 64" title={t`Whoosh Icon Color`} {...props}>
    <Path
      d="M31.748 51.09 27.274 24h-9.152l-4.331 27.262L9.679 24H0l7.646 40h10.003l4.793-26.032 4.826 25.875.028.157h9.998L45 24h-9.229l-4.023 27.09Z"
      fill="#00A887"
    />
    <Path
      d="M44.187 6.723c-.871-.961-2.375-1.315-4.908 1.122-3.379 3.247-4.834 4.337-6.9 4.374-2.47.043-4.696-1.45-5.7-3.693-.68-1.519-1.408-3.639-1.923-6.473-.149-.81-.637-1.546-1.397-1.884a1.87 1.87 0 0 0-.86-.167 1.942 1.942 0 0 0-.861.167c-.76.338-1.248 1.073-1.397 1.884-.76 4.181-2.035 6.838-2.911 8.277a4.14 4.14 0 0 1-2.693 1.91c-2.412.494-4.818-.45-8.919-4.396C3.184 5.409 1.681 5.763.81 6.723-.162 7.796-.22 9.412.428 10.7L4.103 18H40.9l3.675-7.3c.648-1.294.585-2.904-.387-3.977Z"
      fill="#FFD600"
    />
  </Icon>
);

export default WhooshIconColor;
